var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.4 19.02a2.246 2.246 0 00-.558.054v1.767a2.041 2.041 0 00.453.035c.718 0 1.161-.363 1.161-.977 0-.549-.381-.879-1.056-.879zm5.231.018a2.758 2.758 0 00-.61.054v3.915a2.447 2.447 0 00.47.027 1.854 1.854 0 002.023-2.094 1.716 1.716 0 00-1.882-1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 0H3a3 3 0 00-3 3v24a3 3 0 003 3h18a3 3 0 003-3V9zM8.247 21.285a2.781 2.781 0 01-1.944.63 3.345 3.345 0 01-.462-.027v2.139H4.5v-5.9A11.337 11.337 0 016.328 18a2.872 2.872 0 011.83.479 1.755 1.755 0 01.639 1.385 1.928 1.928 0 01-.55 1.422zm5.71 2.032a4.3 4.3 0 01-2.76.772A11.55 11.55 0 019.661 24v-5.876A11.921 11.921 0 0111.49 18a3.849 3.849 0 012.45.639 2.648 2.648 0 011.013 2.261 3.033 3.033 0 01-1 2.422zm5.543-4.162h-2.3v1.367h2.15v1.1H17.2v2.406h-1.357v-5.983H19.5zM15 10.5h-1.5V3l7.5 7.5z"
  })));
}

export default SvgIconPdf;